/**
 * Generates initials from a full name string.
 * Takes the first letter of each word, up to 2 letters total.
 *
 * @param name - The full name string
 * @returns Initials as uppercase string (max 2 characters)
 *
 * @example
 * getInitials("John Doe") // "JD"
 * getInitials("Jane") // "J"
 * getInitials("Mary Jane Watson") // "MJ"
 * getInitials("") // ""
 * getInitials("   ") // ""
 */
export const getInitials = (name: string): string => {
  if (!name || typeof name !== "string") {
    return "";
  }

  const trimmedName = name.trim();
  if (!trimmedName) {
    return "";
  }

  const words = trimmedName.split(/\s+/).filter((word) => word.length > 0);

  if (words.length === 0) {
    return "";
  }

  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }

  // Take first letter of first word and first letter of last word
  const firstInitial = words[0].charAt(0);
  const lastInitial = words[words.length - 1].charAt(0);

  return (firstInitial + lastInitial).toUpperCase();
};
